import '../../common/common.js';
import { DOM } from '../../common/browser';
import { enterCodes, spaceCodes, upCodes, downCodes, homeCodes, endCodes } from '@mands/mns-fe-pattern-library/lib/mns-fe-utilities/keyCodes';
import getKeyCode from '@mands/mns-fe-pattern-library/lib/mns-fe-utilities/getKeyCode';

export default class Accordion {
    constructor(el) {
        this.itemHeaders = el.getElementsByClassName('accordion__section__header');
    }

    addEventHandlers() {
        for (let item of this.itemHeaders) {
            item.addEventListener('click', e => {
                Accordion.toggleContents(e);
                if (e.target.classList.contains('active')) {
                    let utag_link_data = { // eslint-disable-line camelcase
                        link_name: 'help:sparkspay:' + e.target.innerText // eslint-disable-line camelcase
                    };
                    utag.link(utag_link_data); // eslint-disable-line no-undef
                }
            });

            item.addEventListener('keydown', e => {
                this.keyEvents(e);
                if (e.target.classList.contains('active')) {
                    let utag_link_data = { // eslint-disable-line camelcase
                        link_name: 'help:sparkspay:' + e.target.innerText // eslint-disable-line camelcase
                    };
                    utag.link(utag_link_data); // eslint-disable-line no-undef
                }
            });
        }
    }

    keyEvents(e) { // eslint-disable-line complexity
        const code = getKeyCode(e);
        const itemHeadersArray = Array.prototype.slice.call(this.itemHeaders);
        const openCodes = spaceCodes.concat(enterCodes);
        const moveCodes = upCodes.concat(downCodes);

        switch (true) {
            case openCodes.indexOf(code) > -1:
                e.preventDefault();
                Accordion.toggleContents(e);
                break;

            case moveCodes.indexOf(code) > -1: {
                e.preventDefault();
                const target = e.target;
                const index = itemHeadersArray.indexOf(target);
                const direction = downCodes.indexOf(code) > -1 ? 1 : -1;
                const length = itemHeadersArray.length;
                const newIndex = (index + length + direction) % length;
                itemHeadersArray[newIndex].focus();
                break;
            }

            case homeCodes.indexOf(code) > -1:
                e.preventDefault();
                itemHeadersArray[0].focus();
                break;

            case endCodes.indexOf(code) > -1:
                e.preventDefault();
                itemHeadersArray[itemHeadersArray.length - 1].focus();
                break;
        }
    }

    static toggleContents(e) {
        const itemHeader = e.target;
        const nextElement = itemHeader.nextElementSibling;
        itemHeader.classList.toggle('active');
        if (nextElement.className.indexOf('accordion__section__contents--open') === -1) {
            nextElement.className += ' accordion__section__contents--open';
            itemHeader.setAttribute('aria-expanded', 'true');
        } else {
            nextElement.classList.remove('accordion__section__contents--open');
            itemHeader.setAttribute('aria-expanded', 'false');
        }
    }
}

DOM.ready(() => {

    const dropDown = document.getElementById('faq-page-navigation');
    if (dropDown !== null) {
        dropDown.addEventListener('change', (event) => {
            window.location.href = event.target.value;
        });

        dropDown.addEventListener('mousewheel', function () {
            return false;
        });
    }

    const cusAccordionEl = document.querySelector('#faq-section');
    const accordionHeader = document.querySelector('.accordion__section__header');

    if (cusAccordionEl) {
        const accordianObj = new Accordion(cusAccordionEl);
        accordianObj.addEventHandlers();
        if (accordionHeader) {
            accordionHeader.click();
        }
    }

});



// WEBPACK FOOTER //
// /src/pages/sparkspayFAQ/client.js